// export default (function(){
//
//     function DetectService() {
//         this.isAndroid = /android/i.test(navigator.userAgent);
//         this.isWebView = /;\swv\)/.test(navigator.userAgent);
//         this.isIosWebView = /(iPhone|iPod|iPad).*AppleWebKit(?!.*Version)/i.test(navigator.userAgent);
//         this.isFBapp = /FBAV/i.test(navigator.userAgent);
//         this.isiOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
//         this.isSafari = /constructor/i.test(window.HTMLElement) || (function (p) { return p.toString() === "[object SafariRemoteNotification]"; })(!window['safari'] || safari.pushNotification);
//         this.isEdge = /Edge\/\d./i.test(navigator.userAgent);
//     }
//
//     return DetectService;
// })();

export default (function () {
    return {
        isAndroid: /android/i.test(navigator.userAgent),
        isWebView: /;\swv\)/.test(navigator.userAgent),
        isIosWebView: /(iPhone|iPod|iPad).*AppleWebKit(?!.*Version)/i.test(navigator.userAgent),
        isFBapp: /FBAV/i.test(navigator.userAgent),
        isiOS: /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream,
        isSafari: /constructor/i.test(window.HTMLElement) || (function (p) { return p.toString() === "[object SafariRemoteNotification]"; })(!window['safari'] || safari.pushNotification),
        isEdge: /Edge\/\d./i.test(navigator.userAgent)
}
})();
